import { gql } from "@apollo/client";

export const QUERY_APPLICATION = gql`
  query Application($uuid: String!, $status: String) {
    data: applications {
      application(uuid: $uuid, status: $status) {
        uuid
        reference
        modifiedOn
        pricingExpiryDate
        case {
          reference
          uuid
        }
        numberOfApplicants
        applicationDate
        hasDebtsToSettle
        broker {
          firmName
          feeAmount
          brokerFeeAddedToLoan
          lenderFeeAddedToLoan
          email
          name
          phoneNumber
          status
        }
        applicants {
          uuid
          currentAddress {
            address
            addressLine1
            addressLine2
            addressLine3
            buildingName
            buildingNumber
            county
            postcode
            residentialStatus
            stayDurationMonths
            stayDurationYears
            subBuildingName
            subBuildingNumber
            thoroughfare
            townOrCity
          }
          dateOfChange
          dob
          email
          title
          surname
          status
          previousName
          previousAddresses {
            uuid
            townOrCity
            thoroughfare
            subBuildingNumber
            subBuildingName
            stayDurationYears
            stayDurationMonths
            residentialStatus
            postcode
            county
            buildingNumber
            buildingName
            addressLine3
            addressLine2
            addressLine1
            address
          }
          phoneNumber
          nationality
          maritalStatus
          middleName
          hasPermanentUkResideRight
          forename
        }
        employments {
          applicantId
          status
          numberOfJobs
          incomeChangesDetails
          hasOtherSourcesOfIncome
          awareOfAnyChangesToIncome
          anticipatedRetirementAge
          employmentDetail {
            annualBasicSalary
            businessName
            currentYearProjectedDividends
            dailyRate
            dividendFromLatestFinalisedYear
            dividendFromPreviousYear
            employerName
            employmentType
            endDate
            uuid
            latestYearNetProfit
            occupation
            percentBusinessOwned
            previousYearNetProfit
            projectedGrossProfitCurrentTradingYear
            salaryFromLatestFinalisedYear
            salaryFromPreviousYear
            selfEmployedAccountant {
              townOrCity
              thoroughfare
              subBuildingNumber
              subBuildingName
              postcode
              phoneNumber
              firmName
              emailAddress
              county
              buildingNumber
              buildingName
              addressLine3
              addressLine2
              addressLine1
              address
            }
            shareholdingPercentInCompany
            yearsAtEmployer
            monthsAtEmployer
            employmentStatus
            treatedAsEmployedForTax
          }
          employmentOtherIncomeSources {
            annualGrossIncome
            uuid
            source
          }
        }
        expenditure {
          status
          householdExpenditure {
            futureChangeInExpenditure
            changeInExpenditureDetail
            foodDrinkGroceries
            clothingFootwearPersonal
            utilitiesOtherHousing
            furnishingsHouseholdMaintenance
            transportTravel
            communication
            recreationRestaurantsHotels
            insurance
            councilTax
            cigarettesTobacco
            childcareSchoolFees
            adultCare
            maintenanceCsa
            mortgageEndowment
            health
            other
          }
          applicantCredit {
            applicantHasOutstandingCredit
            creditProviders {
              balanceOutstanding
              uuid
              monthlyPayment
              provider
              providerType
              settlementAmount
              consolidate
              isPartConsolidated
            }
          }
        }
        loan {
          loanAmount
          firstChargeLender
          mortgageAgeYears
          mortgageAgeMonths
          firstChargeMortgageValue
          isInterestRateFixedForAnInitialPeriod
          propertyPurchasePrice
          estimatedPropertyValue
          purposeOfLoan
          loanTermMonths
          status
          remainingTermOfFirstChargeLoanYears
          remainingTermOfFirstChargeLoanMonths
          remainingTermOfInitialInterestRatePeriodMonths
        }
        property {
          isSecuredPropertySameAsApplicantAddress
          townOrCity
          thoroughfare
          subBuildingNumber
          subBuildingName
          status
          propertyType
          propertyStyle
          postcode
          noOfBedrooms
          groundRentIfFlat
          county
          buildingNumber
          buildingName
          addressLine3
          addressLine2
          addressLine1
          address
          avmConfidenceLevel
          avmValuation
        }
        other {
          numberOfFinancialDependentsOver17
          numberOfFinancialDependents17Under
          status
        }
        product {
          selectedProductUuid
          status
        }
        confirm {
          status
        }
      }
    }
  }
`;

export const QUERY_ELIGIBLE_PRODUCTS = gql`
  query EligibleProducts($applicationUuid: String) {
    data: applications {
      eligibleProducts(applicationUuid: $applicationUuid) {
        products {
          uuid
          code
          fixedTermCopy
          initialPeriodInterestOnly
          initialRate
          monthlyPayment
          reversionRate
          reversionPayment
          aprc
          maxLtv
          valuationType
          lenderFee
          ercsCopy
        }
        pricingExpiryDate
      }
    }
  }
`;

export const QUERY_APPLICATION_DEBT_CONSOLIDATION = gql`
  query DebtConsolidation($applicationUuid: String!) {
    data: applications {
      debtConsolidation(applicationUuid: $applicationUuid) {
        uuid
        application {
          uuid
          hasDebtsToSettle
          case {
            uuid
            reference
          }
          applicants {
            uuid
            forename
            surname
          }
        }
        loanAmount
        cashOutAccountNumber
        cashOutSortCode
        cashOutApplicant {
          uuid
          forename
          surname
        }
        disbursementBankAccount {
          applicantUuid
          sortCode
          accountNumber
          bankName
        }
        consolidatedAmount
        cashOutAmount
        cashOutPurpose
        creditors {
          uuid
          applicant {
            uuid
            forename
            surname
          }
          providerType
          provider
          sortCode
          accountNumber
          settlementAmount
          isPartConsolidated
          reference
          paidTo
          purpose
        }
      }
    }
  }
`;
